import { ROUTES } from "constants/routes";

export const generateRestaurantWithIdRoute = (id: string) =>
  `${ROUTES.RESTAURANT}/${id}`;
